'use strict';

window.JQuery = window.$ = require('jquery');
// window.angular = require('angular');

angular.module('betosyswebapp', ['ngAnimate', 'ngMaterial', 'ngCookies', 'ngTouch', 'ngSanitize', 'restangular',
  'ui.router', 'pascalprecht.translate', 'jqwidgets', 'ab-base64', 'ui.bootstrap', 'LocalStorageModule',
  'angular-loading-bar', 'cfp.loadingBar', 'angularMoment', 'ncy-angular-breadcrumb', 'dashboard', 'highcharts-ng',
  'timepickerPop', 'ngContextMenu', 'ui-rangeSlider', 'tmh.dynamicLocale', 'dsaComponents', 'daterangepicker',
  'toggle-switch', 'trackMap', 'trackReporting', 'telephone', 'driverDashboard', 'portalCommand', 'fmsDashboard',
  'tachoHistoryDashboard', 'luegg.directives', 'app.constants', 'contact', 'bookManagement', 'tachoDownloadDashboard', 'sharedConfig'])
  .constant('serverBaseUrl', '/api/fleetapi')
  .constant('localStoragePrefix', 'betoTrack')
  .config(function (localStoragePrefix, serverBaseUrl, localStorageServiceProvider, RestangularProvider) {
    localStorageServiceProvider.setPrefix(localStoragePrefix);
    RestangularProvider.setBaseUrl(serverBaseUrl);
  })
  .config(['$locationProvider', function ($locationProvider) {
    $locationProvider.hashPrefix('');
  }])
  .config(function (dsaComponentsConfig) {
    var config = {
      serverBaseUrl: '/api/fleetapi',
      loginUrl: 'user/login',
      logoutUrl: 'user/logout',
      productName: 'BetoTrack',
      unProtectedStates: ['home'],
      loginSuccessState: 'betotrack.dashboard',
      localStoragePrefix: 'betoTrack',

      adaptClearInput: true,
      jqxCustomSettings: { theme: 'material' }// theme: 'bootstrap',
    };
    dsaComponentsConfig = _.extend(dsaComponentsConfig, config);
  })
  .config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
    cfpLoadingBarProvider.includeSpinner = false;
  }])
  .config(function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
      templateUrl: 'components/breadcrumb/breadcrumb.tpl.html'
    });
  })
  .config(function ($stateProvider, $urlRouterProvider, $translateProvider, defaultI18n) {
    $stateProvider
      .state('app', {
        abstract: true,
        views: {
          'framework': {
            templateUrl: 'components/framework/framework.tpl.html',
            controller: 'FrameworkController',
            controllerAs: 'framework'
          }
        },
        resolve: {
          $title: function () {
            return 'DSA';
          }
        }
      });

    $urlRouterProvider.otherwise('/');

    _.map(defaultI18n, function (val, key) {
      $translateProvider.translations(key, val);
    });
    //i18n

    // Tell the module what language to use by default
    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('en');
    $translateProvider.useSanitizeValueStrategy('escape');
  })
  .config(function (tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern('https://code.angularjs.org/1.6.6/i18n/angular-locale_{{locale}}.js');
  })
  .filter('replacenewline', function () {
    return function (text) {
      return text.replace(/\\n/gm, ' / ');
    };
  })
  .filter('tel', function () {
    return function (tel) {
      if (!tel) {
        return '';
      }
      var value = tel.toString().trim().replace(/^\+/, '');
      if (value.match(/[^0-9]/)) {
        return tel;
      }
      if (value) {
        if (value.length > 20) {
          value = value.slice(0, 20);
        }
        return value.trim();
      }
    };
  })
  .factory('iframeMessageRecieveService', function ($window, localStorageService, commonTrackService, AuthenticationService, $rootScope, toastService, $translate) {


    var service = {
      initRecieveMessage: activate
    };

    return service;

    function activate() {
      activateIncomingMessageHandler();
    }

    function activateIncomingMessageHandler() {
      $window.addEventListener('message', function (event) {
        var loginID = AuthenticationService.GetLoginID();
        if (typeof (event.data) !== 'undefined') {
          if (event.data.eventType === 'zoom_changed') {
            localStorageService.set('mapZoomDetails.' + loginID.username + '.' + event.data.frameId, event.data);
          } else if (event.data.eventType === 'map_init') {
            var mapZoomDetailsLocalStorageVal = localStorageService.get('mapZoomDetails.' + loginID.username + '.' + event.data.frameId);
            var method = 'loadLocalStorageLoomDetails_dsa(' + JSON.stringify(mapZoomDetailsLocalStorageVal) + ')';
            commonTrackService.getFleetServerDetails().then(function (gtsServerSettings) {
              var postMessageObj = { method: 'window.' + method, messageOrigin: $window.location.origin };
              event.source.postMessage(postMessageObj, gtsServerSettings.qualifiedServerURL);
            });
            $rootScope.$broadcast('map_init_event', {});
          } else if (event.data.eventType === 'map_direction_init' || event.data.eventType === 'map_place_changed') {
            $rootScope.$broadcast('map_place_route_int_event', {});
          } else if (event.data.eventType === 'map_rotue_canceled' || event.data.eventType === 'map_option_closed') {
            $rootScope.$broadcast('map_option_canceled_event', {});
          } else if (event.data.eventType === 'init-toast-response') {
            if (event.data.errorType === 'success') {
              toastService.showSuccessToast($translate.instant('errorCodes.track.' + event.data.errorId + '.message'));
            }
          }
          // handle message
        }
      });
    }
  })

  .factory('timeoutHttpIntercept', function ($q) {
    return {
      'request': function (config) {
        config.timeout = 45000;//set request time out to 20 seconds
        return config;
      },
      'responseError': function (rejection) {
        if (rejection.status === 401 && window.location.href.indexOf('login') === -1  || rejection.status === 500 && typeof rejection.data === 'string' &&  rejection.data.indexOf('Error occured while trying to proxy to') > -1 || rejection.status === 503 && window.location.href.indexOf('login') === -1 ) {
          {
            window.location = '/#/login';
            return;
          }
        }
        return $q.reject(rejection);
      }
    };
  })
  .config(function ($httpProvider) {
    $httpProvider.interceptors.push('timeoutHttpIntercept');
  }).run(function ($rootScope, $state,$location, $cookies, AuthenticationService, commonTrackService, vehicleMapWidgetService, fleetMapWidgetService, dsaComponentsConfig, $translate, languageService, dashboard, iframeMessageRecieveService) {

    iframeMessageRecieveService.initRecieveMessage();
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      $state.previous = fromState;
    });

    $rootScope.$on('$stateChangeStart', function (event, toState) {
      if (AuthenticationService.IsLogin()) {
        addDynamicCssClasses();
      }
      vehicleMapWidgetService.setWigetInitialized(false);
      fleetMapWidgetService.setWigetInitialized(false);

      if (toState.name === 'login') {
        _updateDsaComponentCustomConfig();
      }

    });

    //DSA fleetmanagement #bug 88863
    $rootScope.$watch(function(){
      var data = $cookies.get('BetoTrack');
      return data;
    }, function(newValue){

      var isDefined = false;

      if(newValue){
        isDefined = true;
      }

      if(isDefined === false){
        var ignoreLogout = $state.current.url === '/login' ? true : false;
        if(ignoreLogout === false){
            AuthenticationService.logout();
            $location.path( '/login' );
        }
      }

    }, true);

    var widgetKeys = Object.keys(dashboard.widgets);

    function translzteTltleAndDescription() {
      if (widgetKeys.length) {
        for (var i = 0; i < widgetKeys.length; i++) {
          var key = widgetKeys[i];
          var value = dashboard.widgets[key];
          if (value.resolve && value.resolve.title) {
            dashboard.widgets[key].title = $translate.instant(dashboard.widgets[key].resolve.title(), null, null, languageService.getLanguageSettings().language);
          }
          if (value.resolve && value.resolve.description) {
            dashboard.widgets[key].description = $translate.instant(dashboard.widgets[key].resolve.description(), null, null, languageService.getLanguageSettings().language);
          }
        }
      }
    }

    $rootScope.$on('$locationChangeStart', function (event, toState) {
      if (toState.indexOf('dashboard') > -1) {
        dashboard.setLocale(languageService.getLanguageSettings().language + '-' + languageService.getLanguageSettings().language.toUpperCase());
        translzteTltleAndDescription();
      }

    });


    function addDynamicCssClasses() {
      var userSettings = commonTrackService.getGtsLocalStorageSettings();
      if (userSettings && userSettings.gridsSetting) {
        for (var i = 0; i < Object.keys(userSettings.gridsSetting).length; i++) {
          if (!$('#' + userSettings.gridsSetting[Object.keys(userSettings.gridsSetting)[i]].backgroundColor)[0]) {
            var bgColor = userSettings.gridsSetting[Object.keys(userSettings.gridsSetting)[i]].backgroundColor;
            $('<div></div>', {
              html: '&shy;<style id=' + bgColor + '>' + '.rgb-' + bgColor + ' {  background-color: #' + bgColor + '; }' + '</style>'
            }).appendTo('body');
          }
        }
      }
    }

    function _updateDsaComponentCustomConfig() {
      dsaComponentsConfig.customLoginID = function (loginID) {
        loginID.Account = commonTrackService.getGeneralSettings().login.accountID;
      };
      dsaComponentsConfig = _.extend(dsaComponentsConfig, dsaComponentsConfig);
    }

    _updateDsaComponentCustomConfig();
  });




// WEBPACK FOOTER //
// ./.tmp/app/app.js